import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getCart,
  updateItemQuantity,
  removeItem,
} from "@ten24/slatwall-storefront-react-private/global";
import { useEffect, useState } from "react";
import DynamicPage from "../DynamicPage/DynamicPage";
import { CartLineItem } from "../../components/Cart/CartLineItem";
import { QuoteCheckOut } from "../../components/Quote/QuoteCheckOut";
import queryString from "query-string";

const Quote = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [removeitem, setRemoveitem] = useState(false);
  const cart = useSelector((state) => state.cart);
  const { orderID, orderItems, isFetching } = cart;
  const location = useLocation();
  const { allItems } = queryString.parse(location.search);

  const cartAndQuoteItems = orderItems.filter(
    (item) => item.parentOrderItemID === ""
  );

  const quoteReadyItems =
    allItems === "1"
      ? cartAndQuoteItems
      : cartAndQuoteItems.filter((item) => item.quoteOnly);

  useEffect(() => {
    dispatch(getCart());
  }, [dispatch]);

  return (
    <DynamicPage ignoreLayout={true}>
      <div className="container my-5">
        {orderItems && orderItems.length === 0 && (
          <div className="text-center p-3">
            <h3>{t("frontend.cart.empty_cart")}</h3>
          </div>
        )}

        {isFetching && removeitem && (
          <div className="alert alert-success">
            {t("frontend.cart.removeCartItem")}
          </div>
        )}
        <div className="row">
          <div className="col-lg-7 col-md-12">
            {quoteReadyItems && quoteReadyItems.length > 0 && (
              <>
                <div className="card my-4 border-0">
                  <div className="card-header bg-white py-0">
                  <h2>The following items will be sent as quote</h2>
                  </div>
                  <div className="card-body py-0">
                    {quoteReadyItems &&
                      quoteReadyItems.map((orderItem, key) => {
                        return (
                          <CartLineItem
                            key={`${orderItem.orderItemID}-${key}`}
                            orderItem={orderItem}
                            setRemoveitem={setRemoveitem}
                            childBundleItems={quoteReadyItems?.filter(
                              (item) =>
                                item?.parentOrderItemID ===
                                orderItem.orderItemID
                            )}
                            onUpdateQty={(itemCount) => {
                              dispatch(
                                updateItemQuantity(
                                  orderItem.orderItemID,
                                  itemCount
                                )
                              );
                            }}
                            onRemoveItem={(event) => {
                              setRemoveitem(true);
                              event.preventDefault();
                              dispatch(removeItem(orderItem.orderItemID));
                            }}
                          />
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>
          {orderItems && orderItems.length !== 0 && (
            <div className="col-lg-4 offset-lg-1 col-md-12">
              <QuoteCheckOut
                quoteReadyItems={quoteReadyItems}
                orderID={orderID}
              />
            </div>
          )}
        </div>
      </div>
    </DynamicPage>
  );
};

export default Quote;
